import React from 'react';
import Card from '../body/card';
import Card2 from '../body/card2';
import './index.css'; // Include your styles
import ServiceCard from './serviceCard';
import { useNavigate } from "react-router-dom";
const Services = () => {
    const navigate = useNavigate();

    const sections = [
        {
            title: "Safe & Comfortable Living",
            description:
                "We provide well-managed paying guest accommodations that prioritize comfort, hygiene, and security. Every home is equipped with modern facilities and thoughtful services to make residents feel safe, supported, and at home.",
            buttonText: "Find Your PG",
            columns: [
                {
                    subTitle: "Hygiene & Cleanliness",
                    subDescription:
                        "We maintain the highest standards of cleanliness in all areas—from rooms to common spaces. Our services include:",
                    points: [
                        "Daily housekeeping for rooms and shared areas.",
                        "Sanitized washrooms and kitchens.",
                        "Clean linen and bedding management.",
                        "Regular pest control and upkeep to ensure a healthy environment.",
                    ],
                },
                {
                    subTitle: "Safety & Security",
                    subDescription:
                        "Your safety is our top priority. We implement robust measures so you can live with peace of mind:",
                    points: [
                        "24/7 CCTV surveillance and security personnel.",
                        "Secure entry and exit with controlled access.",
                        "Emergency protocols and first-aid ready.",
                        "Resident verification and guest management for a safe community.",
                    ],
                },
            ],
        },
        {
            title: "Food & Amenities",
            description:
                "Enjoy nutritious and hygienic meals, modern amenities, and services designed to make your stay comfortable and convenient.",
            buttonText: "Explore Amenities",
            columns: [
                {
                    subTitle: "Tiffin & Meals",
                    subDescription:
                        "Home-style meals prepared with care, balancing taste and nutrition:",
                    points: [
                        "Daily breakfast, lunch, and dinner options.",
                        "Special dietary accommodations on request.",
                        "Fresh, hygienically prepared food with quality ingredients.",
                    ],
                },
                {
                    subTitle: "Essential Amenities",
                    subDescription:
                        "Facilities designed to make life easier and more enjoyable:",
                    points: [
                        "High-speed Wi-Fi for work and study.",
                        "Power backup to keep your devices running.",
                        "Lifts for easy access in multi-floor buildings.",
                        "Common lounges and recreational areas.",
                        "Laundry service and clean linen management.",
                    ],
                },
            ],
        },
        {
            title: "Comfort & Convenience",
            description:
                "We focus on creating an environment that feels like home, with attention to detail, resident comfort, and smooth operations.",
            buttonText: "Book a Room",
            columns: [
                {
                    subTitle: "Well-Designed Rooms",
                    subDescription:
                        "Rooms are thoughtfully designed for comfort and functionality:",
                    points: [
                        "Spacious, furnished rooms with proper ventilation.",
                        "Personal storage and study/workspaces.",
                        "Regular maintenance and repairs handled promptly.",
                    ],
                },
                {
                    subTitle: "Powerful Support & Services",
                    subDescription:
                        "We make sure residents have everything they need for a hassle-free stay:",
                    points: [
                        "On-site staff for daily assistance.",
                        "Quick resolution of any issues or complaints.",
                        "Regular updates and communication to residents.",
                    ],
                },
            ],
        },
        {
            title: "Resident Experience & Community",
            description:
                "Beyond rooms and facilities, we cultivate a positive, respectful, and vibrant community for all our residents.",
            buttonText: "Join Our PG",
            columns: [
                {
                    subTitle: "Community & Engagement",
                    subDescription:
                        "Creating a supportive and friendly environment:",
                    points: [
                        "Organized events and meet-ups for residents.",
                        "Encouraging a respectful and inclusive culture.",
                        "Feedback mechanisms to continuously improve the living experience.",
                    ],
                },
                {
                    subTitle: "Transparency & Trust",
                    subDescription:
                        "We operate with honesty, openness, and accountability:",
                    points: [
                        "Clear rental agreements and policies.",
                        "Transparent pricing with no hidden charges.",
                        "Resident support available for queries and guidance.",
                    ],
                },
            ],
        },
    ];



    return (
        <>
            <div className="app-container">
                <header className="header">
                    <h1 className="header-main-content" >Our Services</h1>
                    <p className='header-body-content'>
                        Finding the perfect PG shouldn’t be stressful. We provide safe, comfortable, and well-managed paying guest accommodations with all the amenities you need: home-style tiffin service, top-notch hygiene, 24/7 CCTV surveillance, secure access, power backup, lifts, high-speed Wi-Fi, clean common areas, and recreational spaces. Our focus is on creating a worry-free living experience so you can study, work, and relax with peace of mind.
                    </p>
                    <button className='service-btn' onClick={() => navigate("/contactUs")}>
                        Book Your PG Now
                    </button>

                    <img
                        src="./1.jpg" // Replace with your image URL
                        alt="Header visual"
                        className="header-img"
                        style={{
                            marginBottom: "120px", marginTop: "80px", paddingLeft: "60px",
                            paddingRight: "60px"
                        }}
                    />
                </header>
                <section style={{ background: "#FEE5E8", paddingTop: "120px", paddingBottom: "120px" }}>
                    <div className="container" style={{ background: "#FEE5E8" }}>
                        {sections.map((section, index) => (
                            <div key={index} className="row mb-5 align-items-start" style={{ background: "#FEE5E8" }}>
                                <div className="col-md-5 sticky-title" style={{ background: "#FEE5E8" }}>
                                    <h2 className="fw-bold">{section.title}</h2>
                                    <p style={{ textAlign: "justify", color: "#242424", fontWeight: "500" }}>{section.description}</p>
                                    <button onClick={() => navigate("/contactUs")} className="btn btn-danger btn-red-background" style={{ whiteSpace: "nowrap", width: "fit-content" }}>{section.buttonText}</button>
                                </div>
                                <div className="col-md-7 side-content-service-web">
                                    {section.columns.map((column, colIndex) => (
                                        <div key={colIndex} className="mb-4">
                                            <h3 style={{ color: "color: #242424", fontWeight: "500" }}>{column.subTitle}</h3>
                                            <p style={{ textAlign: "justify", color: "#4E4E4E" }}>{column.subDescription}</p> {/* Subtitle description */}
                                            < ul >
                                                {
                                                    column.points.map((point, pointIndex) => (
                                                        <li style={{
                                                            color: "#4E4E4E",
                                                            fontWeight: "400",
                                                            fontStyle: "normal"

                                                        }} key={pointIndex}>{point}</li>
                                                    ))
                                                }
                                            </ul>
                                        </div>
                                    ))}
                                </div>
                            </div>
                        ))
                        }
                    </div >
                </section >

                <div style={{ marginTop: "120px", display: "flex", justifyContent: "center", alignItems: "center" }}>
                    <ServiceCard />
                </div>
                <section
                    style={{ marginTop: "120px", color: "white", padding: "60px 120px" }}
                    className="service-tile-section-3"
                >
                    <h2
                        style={{ textAlign: "center", marginBottom: "40px", color: "black", fontWeight: "600" }}
                        className="mobile-getting-started-service"
                    >
                        Getting Started is Easy!
                    </h2>
                    <p style={{ textAlign: "center", marginBottom: "40px", color: "black" }}>
                        We make finding the perfect paying guest accommodation seamless and stress-free. Whether you need a short-term stay, long-term residency, or specific amenities, our flexible options ensure a comfortable experience tailored to your needs:
                    </p>
                    <div
                        className="service-tile-mobile"
                        style={{
                            display: "flex",
                            justifyContent: "center",
                            gap: "20px",
                        }}
                    >
                        {[
                            {
                                title: "Monthly Stays",
                                hoverDescription: "Ideal for residents looking for a long-term, hassle-free stay with full access to amenities like Wi-Fi, tiffin service, lifts, and power backup.",
                                src: "./service1.png"
                            },
                            {
                                title: "Short-Term Stays",
                                hoverDescription: "Perfect for students or professionals needing temporary accommodations with flexible booking, clean rooms, and secure facilities.",
                                src: "./service2.png"
                            },
                            {
                                title: "Premium Amenities",
                                hoverDescription: "Includes high-standard hygiene, 24/7 CCTV, security, recreational spaces, and home-style meals to make your stay comfortable and worry-free.",
                                src: "./service3.png"
                            },
                            {
                                title: "Custom Requirements",
                                hoverDescription: "We also accommodate special requests like diet-specific tiffin service, AC rooms, extra storage, or personalized room arrangements to suit your needs.",
                                src: "./service4.png"
                            }
                        ].map((service, index) => (
                            <div
                                key={index}
                                style={{
                                    color: "#262626",
                                    borderRadius: "30px",
                                    padding: "20px",
                                    maxWidth: "300px",
                                    textAlign: "left",
                                    minWidth: "300px"
                                }}
                                className="service-tile"
                            >
                                <div className="">
                                    <img src={service.src} alt="index" />
                                    <h3 style={{ marginBottom: "10px", marginTop: "10px", fontSize: "1rem", fontWeight: "bold" }}>
                                        {service.title}
                                    </h3>
                                    <p style={{ textAlign: "left" }}>{service.hoverDescription}</p>
                                </div>
                            </div>
                        ))}
                    </div>
                </section>
                <p style={{ textAlign: "center", marginTop: "30px", color: "black" }}>
                    No matter which option you choose, we’re committed to providing a safe, comfortable, and well-managed PG experience. Let’s make your stay feel like home!
                </p>

                <section style={{ paddingTop: "120px", background: "#FFF5EE", display: "flex", justifyContent: "center", alignContent: "center", flexDirection: "column", alignItems: "center" }}>
                    <div className="text-client">Client Who trust Us</div>
                    <Card />
                    <div style={{ marginTop: "120px", marginBottom: "120px" }}>
                        <Card2 />
                    </div>
                </section>
            </div >
            <section style={{}}>
                <div className="image-container">
                    <img src="./polygon2.png" alt="polygun" style={{ position: "relative", }} />
                </div>
            </section>
        </>
    );
};

export default Services;
